import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "During signal recording and playback, undesired modifications of the signal may occur. Measuring and compensating for these unwanted modifications is called equalization. The process of frequency response restoration through equalization is depicted below.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Not equalized" }, { name: "Equalized" }],
          options: {},
        },
      ],
      extraContent: [[], []],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/16/principle/slide-1-not-equalized.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/16/principle/slide-1-equalized.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
